import { BROADCAST_UPDATE_PRESENTER_SETTINGS } from '@shoflo/studio-redux/actions/types';
import {
  ATTENDEE_DETAILS_CHANGED,
  PRESENTER_AUDIO_BITRATE_CHANGE
} from '@shoflo/studio-redux/constants/SocketEvents';
import {
  setAttendeeName,
  setAttendeeContentShareAudioProfile
} from '@shoflo/studio-redux/actions';
import { updateSource } from 'actions/source';

function updatePresenterSettings(source, payload) {
  return (dispatch, getState, socket) => {
    const { broadcast, attendeeContentShareAudioProfile } = getState();

    const broadcastId = broadcast?._id;

    const action = {
      type: BROADCAST_UPDATE_PRESENTER_SETTINGS,
      request: async () => {
        if (payload.bitRate || payload.contentShareAudioProfile) {
          const data = {
            attendeeId: source.value,
            broadcastId,
            bitRate: payload.bitRate,
            contentShareAudioProfile: payload.contentShareAudioProfile
          };
          socket.emit(PRESENTER_AUDIO_BITRATE_CHANGE, data);
        }
        const currentAttendeeContentAudioProfile =
          attendeeContentShareAudioProfile[source.value];
        if (
          currentAttendeeContentAudioProfile !==
          payload.contentShareAudioProfile
        ) {
          dispatch(
            setAttendeeContentShareAudioProfile(
              source.value,
              payload.contentShareAudioProfile
            )
          );
        }
      }
    };

    const { source_title: title, description, cameraUnavailable } = payload;
    const {
      value: sourceValue,
      description: sourceDescription,
      title: sourceTitle,
      cameraUnavailable: sourceCameraUnavailable
    } = source;
    const didTitleChange = title && title !== sourceTitle;
    // Allow source description to be set to empty string
    const didDescriptionChange = description !== sourceDescription;
    const didCameraStatusChange = cameraUnavailable !== sourceCameraUnavailable;

    if (didTitleChange || didDescriptionChange || didCameraStatusChange) {
      let changes = {
        title: title,
        description: description,
        cameraUnavailable: cameraUnavailable
      };
      dispatch(
        setAttendeeName(sourceValue, title, source?.photo, source?.role)
      );
      dispatch(updateSource(source._id, changes));
      changes = { ...changes, presenterPhoto: source?.photo };
      socket.emit(ATTENDEE_DETAILS_CHANGED, {
        ...changes,
        attendeeId: source.value,
        broadcastId
      });
      return source;
    }
    dispatch(action);
  };
}

export default updatePresenterSettings;
